import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MatSelect} from '@angular/material/select';
import {FormControl, FormGroup} from '@angular/forms';
import {SelectMenuModel} from '@shared/components/select-menu/model/select-menu.model';

@Component({
    selector: 'app-select-menu-no-label',
    templateUrl: './select-menu-no-label.component.html',
    styleUrls: ['./select-menu-no-label.component.scss']
})
export class SelectMenuNoLabelComponent implements AfterViewInit, OnInit {
    @ViewChild(MatSelect) select: MatSelect;
    @ViewChild('label') label: ElementRef;
    @Input() tabIndex: number;
    @Input() options: SelectMenuModel[];
    @Input() dropdownHeight: number;
    @Input() labelClasses: string;
    @Input() selectLabel: string;
    @Input() placeholder: string;
    @Input() requiredField = false;
    @Input() showDeselectedOptions = true;
    @Input() fontSizeClasses: string;
    @Input() disabled = false;
    @Input() ariaLabel: string;
    @Input() selectedId: any;
    @Input() formFieldControl: FormControl;
    @Input() formFieldGroup!: FormGroup;
    @Input() cssClasses: string;
    @Input() optionCssClasses: string;
    @Output() valueChangeEvent = new EventEmitter();
    @Output() keyUpChangeEvent = new EventEmitter<KeyboardEvent>();

    keyboardFocus: boolean;

    ngOnInit(): void {
        if (this.requiredField === true) {
            this.showDeselectedOptions = false;
        }
        if (this.formFieldControl === undefined) {
            this.formFieldControl = new FormControl({value: null, disabled: this.disabled});
        }
    }

    onKeyUp(event: KeyboardEvent): void {
        this.keyUpChangeEvent.emit(event);
        this.keyboardFocus = true;
    }

    valueChanged(value: any): void {
        this.valueChangeEvent.emit(value);

        if (this.requiredField === true) {
            this.labelClasses = 'asterisk--after';
        }
    }

    ngAfterViewInit(): void {
        if (this.requiredField === true) {
            this.select._elementRef?.nativeElement.children[0].querySelector('span.mat-select-placeholder').classList.add('asterisk--after');
            this.label?.nativeElement.classList.add('asterisk--after');
        }
    }
}
